export const formatLocalDate = (utcDateString: string): string => {
  const utcDate = new Date(
    utcDateString.endsWith('Z') ? utcDateString : `${utcDateString}Z`,
  );

  if (isNaN(utcDate.getTime())) {
    console.error(`Invalid date string: ${utcDateString}`);
    return '';
  }

  // 'YYYY-MM-DD' format
  const formatter = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  const parts = formatter.formatToParts(utcDate);

  let year = '';
  let month = '';
  let day = '';
  let hour = '';
  let minute = '';

  for (const part of parts) {
    switch (part.type) {
      case 'year':
        year = part.value;
        break;
      case 'month':
        month = part.value;
        break;
      case 'day':
        day = part.value;
        break;
      case 'hour':
        hour = part.value;
        break;
      case 'minute':
        minute = part.value;
        break;
      default:
        break;
    }
  }

  return `${year}-${month}-${day} ${hour}:${minute}`;
};

// Define a function to convert minutes to HH:MM format
export const convertMinutesToHHMM = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
